import { makeAutoObservable } from 'mobx'
import { RootStore } from './RootStore'
import { ConnectedWallet } from '@privy-io/react-auth'

export class WalletsStore {
  root: RootStore

  wallets: ConnectedWallet[] = []

  constructor(root: RootStore) {
    this.root = root
    makeAutoObservable(this)
  }

  setWallets(wallets: ConnectedWallet[]) {
    this.wallets = wallets
  }

  get connected() {
    return this.wallets.find((o) => o.address === this.root.user.privyUser?.wallet?.address)
  }

  async resolveProvider() {
    return this.root.wallets.connected?.getEthersProvider()
  }
}
